import React from "react";

import { Visible } from "../../../core/components";
import { getFileUrl } from "../../../core/config/api.js";

import RequestForm from "./RequestForm";

const ProductRow = ({
  item: { clientName, product, isUnknwon },
  isOrder,
  isEditing,
  paidOffline,
  requestType,
}) => {
  return (
    <tr>
      <Visible when={clientName}>
        <td>
          <div className="main-text first-left">{clientName}</div>
        </td>
      </Visible>
      <td>
        <Visible when={!isUnknwon}>
          <img src={getFileUrl(product?.images?.[0]?.id)} width="181" />
        </Visible>
      </td>
      <td>
        <Visible when={!isUnknwon}>
          <div className="main-text">{product?.brand?.name}</div>
          <div className="secondary-text">{product?.model?.name}</div>
          <div className="info-text">
            {product?.values?.dial_color?.value}
            &nbsp;/&nbsp;
            {product?.values?.case_diameter?.value}
          </div>
          <div className="info-text">{product?.reference_number}</div>
        </Visible>
      </td>
      <td style={{ display: "none" }} />
      <td>
        <RequestForm
          isOrder={isOrder}
          paidOffline={paidOffline}
          isEditing={isEditing}
          requestType={requestType}
        />
      </td>
    </tr>
  );
};

export default ProductRow;
